import { VideoFlight } from "@nova/protobuf"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { PluginSpec, staticIcon } from "plugins/plugin-registry"
import { selectOpenVideoFlights } from "plugins/Video/state/selectors"
import { openVideoFlight } from "plugins/Video/state/thunks"
import { useMemo } from "react"

export const getUseVideoMapNodes = (spec: PluginSpec<VideoFlight>) => {
    const useVideoMapNodes = () => {
        const dispatch = useAppDispatch()
        const entities = useAppSelector(spec.selectAllEntities)
        const openVideoFlightIds = useAppSelector(selectOpenVideoFlights)
        const entityData = useMemo(() => {
            return entities
                .filter((entity) => {
                    return !entity.archivedTimestamp && !!entity.startingPosition
                })
                .map((entity) => {
                    return {
                        id: entity.id,
                        position: {
                            lat: entity.startingPosition!.latitude,
                            lng: entity.startingPosition!.longitude,
                        },
                        visible: entity.visible,
                        locked: !!entity.locked,
                        active: openVideoFlightIds.includes(entity.id),
                        onClick: () => {
                            dispatch(openVideoFlight({ flightId: entity.id }))
                        },
                        iconSrc: staticIcon({
                            default: "/icons/video/default.svg",
                            hover: "/icons/video/hover.svg",
                        }),
                    }
                })
        }, [dispatch, entities, openVideoFlightIds])
        return entityData
    }
    return useVideoMapNodes
}
